import React from "react";

const ShowPassword = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="14"
      >
        <path d="M0 0H14V14H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M8.7252 7.4375C8.7252 8.39686 7.95277 9.17463 7 9.17463C6.04723 9.17463 5.2748 8.39686 5.2748 7.4375C5.2748 6.47814 6.04723 5.70037 7 5.70037C7.95277 5.70037 8.7252 6.47814 8.7252 7.4375ZM13.9194 7.69738C12.375 9.92368 9.85187 11.375 7 11.375C4.14813 11.375 1.62497 9.92368 0.0805669 7.69738C-0.0268556 7.54242 -0.0268556 7.33281 0.0805669 7.17786C1.62497 4.95132 4.14813 3.5 7 3.5C9.85187 3.5 12.375 4.95132 13.9194 7.17762C14.0269 7.33281 14.0269 7.54219 13.9194 7.69738ZM9.53029 7.4375C9.53029 6.03042 8.39741 4.88971 7 4.88971C5.60259 4.88971 4.46971 6.03042 4.46971 7.4375C4.46971 8.84458 5.60259 9.98529 7 9.98529C8.39741 9.98529 9.53029 8.84458 9.53029 7.4375Z"
          fill="black"
          fillOpacity="0.67"
        />
      </g>
    </svg>
  );
};

export default ShowPassword;
